// Fixed, standardized outcome names — mirrors backend/models/OutcomeAlgorithm.js's
// OUTCOME_TYPES enum exactly. Kept in sync manually since frontend/backend don't
// share code. This is the single source of truth on the frontend — every picker
// (Outcome Algorithm creation, Action outcome binding, Event outcome valuation,
// Fundshare clearing-outcome selection) imports from here.
export const OUTCOME_TYPES = [
  'Nitrogen (kg/yr)', 'Phosphorus (kg/yr)', 'Carbon (Tonnes CO2e/yr)', 'BNG (units)',
  'Water Storage (m3)', 'Run-off intercepted (m3/yr)', 'VWBA (units)',
  'Sediment (kg/yr)', 'Pesticide (Risk Reduction %)'
];
